import { useEffect, useState, useRef } from 'react'
import Image from 'next/legacy/image'
import { Text } from 'components/atomic'
import { FAQS } from 'constants/faqs'

type FaqProps = {
  dataType: 'claws' | 'variants' | 'redeem-founders-pass' | 'deadrop' | 'tower-key' | 'ugc' | 'driver-key'
}

const Faq = ({ dataType }: FaqProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [graphicTop, setGraphicTop] = useState(0)
  const [activeFaq, setActiveFaq] = useState(0)
  const data =
    dataType == 'claws'
      ? FAQS.claws
      : dataType == 'variants'
        ? FAQS.variants
        : dataType == 'deadrop'
          ? FAQS.deadrop
          : dataType == 'tower-key'
            ? FAQS.towerKey
            : dataType == 'ugc'
              ? FAQS.ugc
              : dataType == 'driver-key'
                ? FAQS.driverKey
                : FAQS.redeemFoundersPass

  useEffect(() => {
    setTimeout(function () {
      if (ref.current) {
        setGraphicTop(ref.current.clientHeight - 656)
      }
    }, 500)
  }, [dataType])

  const toggleFaq = (id) => {
    if (id == activeFaq) {
      setActiveFaq(0)
    } else {
      setActiveFaq(id)
    }
  }

  return (
    <div id="faq" className="relative" ref={ref}>
      <div className="mx-auto px-0 py-16 sm:max-w-[580px] sm:py-[120px] md:max-w-[684px] lg:max-w-[842px]">
        <Text className="mb-8 px-6 text-center tracking-tighter" variant="h2" tag="h2">
          Frequently Asked Questions
        </Text>
        <Text variant="p2" tag="p" className="mb-11 px-6 text-center uppercase text-white/70">
          We Got You Covered
        </Text>
        <div className="md:px-6 lg:px-6">
          {data.map((faq, index) => (
            <div
              key={index}
              className={
                (faq.id == activeFaq ? 'border-1 bg-primary/70 ' : 'border-2 ') +
                'relative mb-2 cursor-pointer border-solid border-[#454340] py-4 pl-4 pr-12 sm:p-10'
              }
              onClick={() => toggleFaq(faq.id)}
            >
              <div className="absolute right-4 top-4 h-9 w-8 sm:right-[33px] sm:top-[26px] sm:h-[46px] sm:w-[40px]">
                {faq.id == activeFaq ? (
                  <Image src="/images/claws-nft/collapse.png" width={40} height={40} alt="Collapse Icon" />
                ) : (
                  <Image src="/images/claws-nft/expand.png" width={40} height={40} alt="Expand Icon" />
                )}
              </div>
              <div className="text-[22px] font-semibold sm:max-w-md md:max-w-lg lg:max-w-2xl">{faq.question}</div>
              <div
                className={(faq.id == activeFaq ? '' : 'hidden ') + 'mt-6 text-base text-white/70'}
                dangerouslySetInnerHTML={{ __html: faq.answer }}
              ></div>
            </div>
          ))}
        </div>
      </div>
      <div className="absolute right-0 -z-10 hidden h-[656px] w-[665px] sm:block" style={{ top: graphicTop }}>
        <Image src="/images/claws-nft/mask.png" layout="fill" objectFit="cover" priority alt="Mask" />
      </div>
    </div>
  )
}

export default Faq
